import React from 'react'
import { connect } from 'react-redux'

import { Button } from '@material-ui/core'

import { generateAnswer } from '../actions'

import './index.scss'

class GenerateAnswer extends React.PureComponent {
    constructor() {
        super()

        this.state = {
            canManuallySendMessage: false,
        }

        this.generateAnswer = this.generateAnswer.bind(this)
    }

    componentDidMount() {
        this.checkCanManuallySendMessage()
    }

    componentDidUpdate() {
        this.checkCanManuallySendMessage()
    }

    checkCanManuallySendMessage() {
        const { historicalDialogue } = this.props

        if (!historicalDialogue) {
            return
        }

        const lastMessage = [...historicalDialogue].pop()

        let aiCommunicationStopped = historicalDialogue.find(
            element => element.StopAiCommunication && element.StopAiCommunication === 1
        )

        aiCommunicationStopped = Boolean(aiCommunicationStopped)

        let canManuallySendMessage = false

        if (
            lastMessage
            && lastMessage.Initiator === 'human'
            && !aiCommunicationStopped
        ) {
            canManuallySendMessage = true
        }

        this.setState({ canManuallySendMessage })
    }

    generateAnswer() {
        const { historicalDialogue } = this.props

        const lastMessage = [...historicalDialogue].pop()

        this.props.generateAnswer(lastMessage)
    }

    render() {
        const { canManuallySendMessage } = this.state
        const { generateAnswerLoading } = this.props

        return (
            <React.Fragment>
                {canManuallySendMessage && !generateAnswerLoading && (
                    <div className='GenerateAnswer'>
                        <Button
                            color='primary'
                            size='small'
                            onClick={this.generateAnswer}
                            variant='outlined'
                        >
                            Generate answer
                        </Button>
                    </div>
                )}
            </React.Fragment>
        )
    }
}

const mapStateToProps = state => {
    const {
        historicalDialogueLoading,
        historicalDialogue,
    } = state.operatorDashboard

    const { generateAnswerLoading } = state.operatorDashboardDetails

    return {
        generateAnswerLoading,
        historicalDialogueLoading,
        historicalDialogue,
    }
}

export default connect(mapStateToProps, { generateAnswer })(GenerateAnswer)
